/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Cpf_CnpjInputs */

const en_clients_field_cpf_cnpj = /** @type {(inputs: Clients_Field_Cpf_CnpjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CPF/CNPJ`)
};

const pt_br2_clients_field_cpf_cnpj = /** @type {(inputs: Clients_Field_Cpf_CnpjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CPF/CNPJ`)
};

/**
* | output |
* | --- |
* | "CPF/CNPJ" |
*
* @param {Clients_Field_Cpf_CnpjInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_cpf_cnpj = /** @type {((inputs?: Clients_Field_Cpf_CnpjInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Cpf_CnpjInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_cpf_cnpj(inputs)
	return pt_br2_clients_field_cpf_cnpj(inputs)
});